import React from "react";
import Project from "../../store/models/Project";

export const ProjectContext = React.createContext<Project | undefined>(
  undefined
);
